module.exports = __webpack_public_path__ + "img/calendar.04866bee.svg";